import { render, staticRenderFns } from "./CentralHeatingDataRecordList.vue?vue&type=template&id=54502b40&scoped=true"
import script from "./CentralHeatingDataRecordList.vue?vue&type=script&lang=js"
export * from "./CentralHeatingDataRecordList.vue?vue&type=script&lang=js"
import style0 from "./CentralHeatingDataRecordList.vue?vue&type=style&index=0&id=54502b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54502b40",
  null
  
)

export default component.exports